import { apiAxios } from '@/api'
import { fetchWrapper } from '../reducers/fetch'

export const fetchInvoicePaymentUrl = (invoiceId: string) =>
  fetchWrapper({
    fetchFunction: async () => {
      const response = await apiAxios.get<string>(
        `/finances/api/v2/invoices/${invoiceId}`
      )
      return response.data
    },
  })
